"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrderError = void 0;
// These are seller facing order errors.
var OrderError;
(function (OrderError) {
    OrderError["BAD_ADDRESS"] = "BAD_ADDRESS";
    OrderError["BAD_ADDRESS_DDP"] = "BAD_ADDRESS_DDP";
    OrderError["BAD_PRODUCT_INFO"] = "BAD_PRODUCT_INFO";
    OrderError["CANNOT_SHIP_HAZMAT"] = "CANNOT_SHIP_HAZMAT";
    OrderError["CARRIER_NETWORK_ERR"] = "CARRIER_NETWORK_ERR";
    OrderError["CUSTOMS_VALUE_LIMIT_EXCEEDED"] = "CUSTOMS_VALUE_LIMIT_EXCEEDED";
    OrderError["DDU_NOT_ALLOWED"] = "DDU_NOT_ALLOWED";
    OrderError["DSKU_NEVER_INBOUNDED"] = "DSKU_NEVER_INBOUNDED";
    OrderError["INTERNATIONAL_ADDRESS"] = "INTERNATIONAL_ADDRESS";
    OrderError["INVALID_CUSTOMS_ITEMS_CURRENCY_CODE"] = "INVALID_CUSTOMS_ITEMS_CURRENCY_CODE";
    OrderError["INVENTORY_ERR"] = "INVENTORY_ERR";
    OrderError["LABEL_PURCHASE_FAILURE"] = "LABEL_PURCHASE_FAILURE";
    OrderError["MISSING_CUSTOMS_INFO"] = "MISSING_CUSTOMS_INFO";
    OrderError["MISSING_DDP_TAG"] = "MISSING_DDP_TAG";
    OrderError["MISSING_REMOVAL_FEE_SPECS"] = "MISSING_REMOVAL_FEE_SPECS";
    OrderError["MISSING_SHIPPING_SPECIFICATIONS_FOR_HAZMAT"] = "MISSING_SHIPPING_SPECIFICATIONS_FOR_HAZMAT";
    OrderError["NO_FEDEX_RATES"] = "NO_FEDEX_RATES";
    OrderError["NO_RATES"] = "NO_RATES";
    OrderError["NO_REMOVAL_PROPOSAL"] = "NO_REMOVAL_PROPOSAL";
    OrderError["OVERSIZED_DIMS"] = "OVERSIZED_DIMS";
    OrderError["PARTIAL_FULFILL_FAILED"] = "PARTIAL_FULFILL_FAILED";
    OrderError["PARTIAL_SHIP_UPDATE_FAILED"] = "PARTIAL_SHIP_UPDATE_FAILED";
    OrderError["PARTIALLY_SHIPPED"] = "PARTIALLY_SHIPPED";
    OrderError["PROMISE_TIME_EXPIRED"] = "PROMISE_TIME_EXPIRED";
    OrderError["REMOVAL_ON_HOLD"] = "REMOVAL_ON_HOLD";
    OrderError["REMOVALS_MINIMUM_NOT_MET"] = "REMOVALS_MINIMUM_NOT_MET";
    OrderError["SHIPPING_METHOD_NOT_SUPPORTED_DDP"] = "SHIPPING_METHOD_NOT_SUPPORTED_DDP";
    OrderError["STOCKOUT"] = "STOCKOUT";
    OrderError["STOCKOUT_AT_INGESTION"] = "STOCKOUT_AT_INGESTION";
    OrderError["UNKNOWN"] = "UNKNOWN";
    OrderError["UNKNOWN_SFP_STATUS"] = "UNKNOWN_SFP_STATUS";
    OrderError["UNREGISTERED_PRIME_PRODUCTS"] = "UNREGISTERED_PRIME_PRODUCTS";
    OrderError["UNSUPPORTED_DESTINATION"] = "UNSUPPORTED_DESTINATION";
    OrderError["WAREHOUSE_ERR"] = "WAREHOUSE_ERR";
    OrderError["NON_PLT_ORDER_NOT_SUPPORTED"] = "NON_PLT_ORDER_NOT_SUPPORTED";
})(OrderError = exports.OrderError || (exports.OrderError = {}));
//# sourceMappingURL=OrderError.js.map